import VehicleDamage from './VehicleDamage';

export default VehicleDamage;